module.exports = __webpack_public_path__ + "assets/webgl/matcap_title.jpg.bef22409.webp";